import * as Types from '@battlefly/__generated__/globalTypes';

import { gql } from '@apollo/client';
import { CoreModBlueprintFieldsFragmentDoc } from './fragments';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBattleLogByBattleByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetBattleLogByBattleByIdQuery = { __typename?: 'Query', combat: { __typename?: 'Combat', id: string, battleFlyWinner: { __typename?: 'BattleFly', id: string }, battleFlyLooser: { __typename?: 'BattleFly', id: string }, log: { __typename?: 'CombatLog', eventLog: Array<any>, textLog: Array<{ __typename?: 'TextLogRecord', when: number, text: string }>, participants: Array<{ __typename?: 'LogParticipant', id: number, battleFlyId: number | null, name: string, cpu: number | null, loot: number | null, arm: number | null, shp: number | null, bat: number | null, engines: number | null, eva: number | null, crit: number | null, hp: number | null, nanoFrame: number | null, sensorsArray: number | null, shrg: number | null, fusionBattery: number | null, dcrit: number | null, hprg: number | null, rcrit: number | null, weapons: Array<{ __typename?: 'LogModInfo', id: number, name: string, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, defense: Array<{ __typename?: 'LogModInfo', id: number, name: string, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, utilities: Array<{ __typename?: 'LogModInfo', id: number, name: string, blueprint: { __typename?: 'ModBlueprint', category: string, description: string, type: Types.ModType, id: string, rarity: Types.Rarity, name: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null }, weapon: { __typename?: 'WeaponBlueprint', reload: number, damagePerFire: number, burst: number } | null, defense: { __typename?: 'DefenseBlueprint', shield: number, armor: number, evasion: number } | null } }>, battleFly: { __typename?: 'BattleFly', appearance: { __typename?: 'BattleFlyAppearance', texture: string | null, image: string | null, bodyColor: Array<string> | null, effect: string | null, stickers: Array<string> | null, headStyle: string | null }, mods: Array<{ __typename?: 'Mod', type: string, name: string, stats: any, rarity: string, damageType: string | null, slot: number, blueprint: { __typename?: 'ModBlueprint', id: string, appearance: { __typename?: 'ModAppearance', image: string | null, model: string, location: string | null } } }> } }> } } | null };

export type Get_Latest_Match_FullQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type Get_Latest_Match_FullQuery = { __typename?: 'Query', getCombatLog: Array<{ __typename?: 'Combat', id: string }> };


export const GetBattleLogByBattleByIdDocument = gql`
    query getBattleLogByBattleById($id: ID!) {
  combat(input: {id: $id}) {
    id
    battleFlyWinner {
      id
    }
    battleFlyLooser {
      id
    }
    log {
      eventLog
      textLog {
        when
        text
      }
      participants {
        id
        battleFlyId
        name
        cpu
        loot
        arm
        shp
        bat
        engines
        eva
        crit
        hp
        nanoFrame
        sensorsArray
        shrg
        fusionBattery
        dcrit
        hprg
        rcrit
        weapons {
          id
          name
          blueprint {
            ...CoreModBlueprintFields
          }
        }
        defense {
          id
          name
          blueprint {
            ...CoreModBlueprintFields
          }
        }
        utilities {
          id
          name
          blueprint {
            ...CoreModBlueprintFields
          }
        }
        battleFly {
          appearance {
            texture
            image
            bodyColor
            effect
            stickers
            headStyle
          }
          mods {
            type
            name
            stats
            rarity
            damageType
            slot
            blueprint {
              id
              appearance {
                image
                model
                location
              }
            }
          }
        }
      }
    }
  }
}
    ${CoreModBlueprintFieldsFragmentDoc}`;

/**
 * __useGetBattleLogByBattleByIdQuery__
 *
 * To run a query within a React component, call `useGetBattleLogByBattleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBattleLogByBattleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBattleLogByBattleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBattleLogByBattleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBattleLogByBattleByIdQuery, GetBattleLogByBattleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBattleLogByBattleByIdQuery, GetBattleLogByBattleByIdQueryVariables>(GetBattleLogByBattleByIdDocument, options);
      }
export function useGetBattleLogByBattleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBattleLogByBattleByIdQuery, GetBattleLogByBattleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBattleLogByBattleByIdQuery, GetBattleLogByBattleByIdQueryVariables>(GetBattleLogByBattleByIdDocument, options);
        }
export type GetBattleLogByBattleByIdQueryHookResult = ReturnType<typeof useGetBattleLogByBattleByIdQuery>;
export type GetBattleLogByBattleByIdLazyQueryHookResult = ReturnType<typeof useGetBattleLogByBattleByIdLazyQuery>;
export type GetBattleLogByBattleByIdQueryResult = Apollo.QueryResult<GetBattleLogByBattleByIdQuery, GetBattleLogByBattleByIdQueryVariables>;
export const Get_Latest_Match_FullDocument = gql`
    query GET_LATEST_MATCH_FULL {
  getCombatLog {
    id
  }
}
    `;

/**
 * __useGet_Latest_Match_FullQuery__
 *
 * To run a query within a React component, call `useGet_Latest_Match_FullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Latest_Match_FullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Latest_Match_FullQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_Latest_Match_FullQuery(baseOptions?: Apollo.QueryHookOptions<Get_Latest_Match_FullQuery, Get_Latest_Match_FullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Latest_Match_FullQuery, Get_Latest_Match_FullQueryVariables>(Get_Latest_Match_FullDocument, options);
      }
export function useGet_Latest_Match_FullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Latest_Match_FullQuery, Get_Latest_Match_FullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Latest_Match_FullQuery, Get_Latest_Match_FullQueryVariables>(Get_Latest_Match_FullDocument, options);
        }
export type Get_Latest_Match_FullQueryHookResult = ReturnType<typeof useGet_Latest_Match_FullQuery>;
export type Get_Latest_Match_FullLazyQueryHookResult = ReturnType<typeof useGet_Latest_Match_FullLazyQuery>;
export type Get_Latest_Match_FullQueryResult = Apollo.QueryResult<Get_Latest_Match_FullQuery, Get_Latest_Match_FullQueryVariables>;